<template>
  <div class="app">
    <a-config-provider :locale="zhCN" :auto-insert-space-in-button="false">
      <router-view></router-view>
    </a-config-provider>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { ConfigProvider as AConfigProvider } from "ant-design-vue";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import "dayjs/locale/zh-cn";
import { checkTokenValidity } from "@/api/login";

// token有效期轮询5分钟一次，每次active重新开始计时
const timer = ref<number>();
const timeout = 1000 * 60 * 5;
const checkToken = () => {
  timer.value = setInterval(() => {
    checkTokenValidity();
  }, timeout);
};

const handlePageVisibilityChange = () => {
  if (document.visibilityState === "visible") {
    checkToken();
  } else {
    timer.value && clearInterval(timer.value);
  }
};
handlePageVisibilityChange();

document.addEventListener("visibilitychange", handlePageVisibilityChange);
</script>

<style lang="less">
html,
body {
  height: 100%;
  padding: 0;
  margin: 0;
}
.ant-modal div[aria-hidden="true"] {
  display: none !important;
}

div {
  box-sizing: border-box;
}

#app {
  height: 100%;
}

.app {
  height: 100%;
}

.common-scroll {
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 8px;
    height: 0px;
  }

  /* 滚动槽 */

  &::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  /* 滚动条滑块 */

  &::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.1);
  }
}

.action-btn {
  font-size: 12px;
  margin-left: 12px;

  .icon {
    vertical-align: sub;
    font-size: 14px;
  }

  &:first-of-type {
    margin-left: 0;
  }
}

.sub-btn {
  background: #ffffff !important;
  // border-radius: 2px;
  border: 1px solid #1890ff !important;
  color: @primary !important;
}

.h-form {
  .ant-input,
  .ant-select-selection-placeholder,
  .ant-input-number-input,
  .ant-picker-input input,
  .ant-select-selection-item {
    font-size: 13px !important;
  }

  .ant-form-item-explain-error {
    font-size: 13px !important;
  }
}

.full-modal {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .ant-modal {
    max-width: 100%;
    height: 100%;
    top: 0;
    padding: 10px;
    //margin: 10px;
  }

  .ant-modal-content {
    display: flex;
    flex-direction: column;
    height: calc(100%);
  }

  .ant-modal-body {
    overflow: auto;
    flex: 1;

    .body-content {
      flex: 1;
      overflow: auto;
    }

    .ant-bottom-btn {
      bottom: 0;
      width: 100%;
    }
  }
}

.common-modal {
  .ant-modal {
    top: 20px;
  }
}

// trade-approve 多行气泡带背景颜色
.message-error-container {
  .ant-message-notice-content {
    padding: 20px;
    background: #fff1f0 !important;
    text-align: left;
  }
}
.message-success-container {
  .ant-message-notice-content {
    padding: 20px;
    background: #f6ffed !important;
    text-align: left;
  }
}
</style>
